module.exports = __webpack_public_path__ + "img/ex-error.b856e7ab.jpg";